// getIsRemoteConfigMerged.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';
import getConfigData from '../selector/getConfigData.js';
import { GrowthBookInitStatus } from '../resource/configConstants.js';

/**
 * Select is remote config merged by priority
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {number} priority - remote config priority.
 * @return {boolean} return true if current priority remote config merged.
 */
const getIsRemoteConfigMerged = createCachedSelector(
  state => getConfigData(state, ['status'], 'initStatus'),
  (state, priority) =>
    !!getOperationData(state, ['config', 'remoteConfigMerged', `${priority}`]),
  (state, priority) =>
    !!getOperationData(state, ['config', 'abTestConfigMerged', `${priority}`]),
  (initStatus, isRemoteConfigMerged, isABTestConfigMerged) => {
    if (
      [
        GrowthBookInitStatus.INITIALIZING,
        GrowthBookInitStatus.UPDATING,
      ].includes(initStatus)
    )
      return false;
    if (
      [GrowthBookInitStatus.SUCCESS, GrowthBookInitStatus.FAILED].includes(
        initStatus
      )
    )
      return true;
    return isRemoteConfigMerged && isABTestConfigMerged;
  }
)((state, priority) => `${priority}`);

export default getIsRemoteConfigMerged;
